import { NavData } from "../navigation/components/navigation-bar/nav-data";

export const NAV_BAR_CONFIG: Array<NavData> = [
  { id: "test", title: "test", icon: "mantis.svg", sortOrder: 1 },
  {
    id: "levelOfCare",
    title: "levelOfCare",
    icon: "levelOfCare.svg",
    sortOrder: 1,
  },
  { id: "vitals", title: "vitals", icon: "vitals.svg", sortOrder: 1 },
  {
    id: "neurological",
    title: "neurological",
    icon: "neurological.svg",
    sortOrder: 1,
  },
  { id: "pain", title: "pain", icon: "pain.svg", sortOrder: 1 },
  {
    id: "respiratory",
    title: "respiratory",
    icon: "respiratory.svg",
    sortOrder: 1,
  },
  { id: "cardio", title: "cardio", icon: "cardio.svg", sortOrder: 1 },
  { id: "gastro", title: "gastro", icon: "gastro.svg", sortOrder: 1 },
  { id: "genito", title: "genito", icon: "genito.svg", sortOrder: 1 },
  { id: "nutrition", title: "nutrition", icon: "nutrition.svg", sortOrder: 1 },
  { id: "skin", title: "skin", icon: "skin.svg", sortOrder: 1 },
  {
    id: "musculoskeletal",
    title: "musculoskeletal",
    icon: "musculoskeletal.svg",
    sortOrder: 1,
  },
  {
    id: "adlsFunctionalNeeds",
    title: "adlsFunctionalNeeds",
    icon: "adlsFunctionalNeeds.svg",
    sortOrder: 1,
  },
  {
    id: "supervisory",
    title: "supervisory",
    icon: "supervisory.svg",
    sortOrder: 1,
  },
  {
    id: "summarycoc",
    title: "summarycoc",
    icon: "summarycoc.svg",
    sortOrder: 1,
  },
  {
    id: "bereavement",
    title: "bereavement",
    icon: "bereavement.svg",
    sortOrder: 1,
  },
  {
    id: "faceToFaceNurse",
    title: "faceToFaceNurse",
    icon: "faceToFace.svg",
    sortOrder: 1,
  },
  {
    id: "faceToFaceMD",
    title: "faceToFaceMD",
    icon: "faceToFace.svg",
    sortOrder: 1,
  },
  { id: "homemaker", title: "homemaker", icon: "homemaker.svg", sortOrder: 1 },
  {
    id: "hospiceaide",
    title: "hospiceaide",
    icon: "hospiceaide.svg",
    sortOrder: 1,
  },
  { id: "safety", title: "safety", icon: "safety.svg", sortOrder: 1 },
  { id: "spirtual", title: "spirtual", icon: "spirtual.svg", sortOrder: 1 },
  {
    id: "socialwork",
    title: "socialwork",
    icon: "socialwork.svg",
    sortOrder: 1,
  },
  { id: "volunteer", title: "volunteer", icon: "volunteer.svg", sortOrder: 1 },
  {
    id: "preferences",
    title: "preferences",
    icon: "preferences.svg",
    sortOrder: 1,
  },
  { id: "his", title: "his", icon: "mantis.svg", sortOrder: 1 },
];

export const NAV_STATUS: {} = {
  test: "complete",
  cardio: "complete",
  gastro: "pending",
  genito: "pending",
};



// WEBPACK FOOTER //
// ./src/mocks/mock-navigation.ts